module.exports = __webpack_public_path__ + "img/DQM.54540d27.jpg";